import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoDeposit} from "./models/DtoDeposit";

@Injectable()
export class DepositService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'deposit'
    }

    public getDepositByNumber = (number: string): Observable<DtoDeposit[]> => {
        return this.http.get<DtoDeposit[]>(`${this.apiUrl}/${number || ''}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/deposit/deposit.service.ts